import assets, { getDay } from "src/isf-2025/assets";
import { achievement } from "src/isf-2025/utils";
import { MappedImage } from "src/utils/fw";

export default function RightBanner() {
    const day = getDay()

    const dayInfo = assets.exploration_zone.popups.rightBoard[day]

    if (!dayInfo) return <></>
    return <MappedImage imageURL={dayInfo.image} links={[
        {
            height: "5.1%",
            // href: dayInfo.ACTION_BTN || "#",
            label: dayInfo.ACTION_BTN_LABEL,
            onClick() {
                achievement(dayInfo.ACTION_BTN_ACHIEVEMENT)
                window.open(dayInfo.ACTION_BTN || "#")
            },
            left: "32%",
            // target: "_blank",
            top: "83.7%",
            width: "36%",
        },
        {
            width: "42%",
            height: "5%",
            left: "7.8%",
            top: "69.7%",
            // target: "_blank",
            // href: dayInfo.topLeft,
            label: dayInfo.topLeftLabel,
            onClick() {
                achievement(dayInfo.topLeftAchievement)
                window.open(dayInfo.topLeft)
            }
        },
        {
            width: "42%",
            height: "5%",
            left: "50.8%",
            top: "69.7%",
            // target: "_blank",
            // href: dayInfo.topRight,
            label: dayInfo.topRightLabel,
            onClick() {
                achievement(dayInfo.topRightAchievement)
                window.open(dayInfo.topRight)
            }
        },
        {
            width: "85%",
            height: "5%",
            left: "7.8%",
            top: "75.1%",
            // target: "_blank",
            // href: dayInfo.bottom,
            label: dayInfo.bottomLabel,
            onClick() {
                achievement(dayInfo.bottomAchievement)
                window.open(dayInfo.bottom)
            }
        }
    ]}>
        <iframe
            src={dayInfo.video}
            style={{
                position: "absolute",
                width: "84.6%",
                height: "51.5%",
                top: "15.6%",
                left: "7.9%",
                border:0
            }}
        />
    </MappedImage>
}
